export const calculateDaysFromToday = (backDate: Date): number => {
  const today = new Date();

  // Calculate the difference in milliseconds
  const differenceInTime = today.getTime() - backDate.getTime();

  // Convert milliseconds to days
  const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

  return differenceInDays - 1;
};
